import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, Button,Stack, Typography } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'

import useTrans from '@/hooks/useTrans'

const ViewSkeleton = () => {
  const trans = useTrans()
  return (
    <Stack className="h-full" justifyContent="space-between" alignItems="center" data-testid="open-position-skeleton">
      <Stack className="md:w-[488px] sm:w-full p-6 rounded-[32px] bg-[#1E2735] sm:my-14 my-6" spacing={2}>
        <Stack>
          <Typography className="text-xl font-bold">
            {trans.liquidity.open_position.add_new_position}
          </Typography>
        </Stack>
        <Stack justifyContent="space-between" alignItems="center" spacing={2}>
          <Box className="bg-[#222C3C] rounded-2xl px-3 py-4 w-full">
            <Stack spacing={2}>
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Stack>
                  <Typography className="text-sm font-normal">
                    {trans.liquidity.open_position.price_range}:
                  </Typography>
                </Stack>
                <Stack direction="row" justifyContent="end" alignItems="center" spacing={0.5}>
                  <Skeleton variant="rounded" width={140} />
                </Stack>
              </Stack>
              <Stack direction="row" justifyContent="flex-end" alignItems="center">
                <Skeleton variant="rounded" width={80} />
              </Stack>
            </Stack>
          </Box>
          <Stack justifyContent="space-between" alignItems="center" className="w-full">
            <Box className="w-full bg-[#141A23] rounded-2xl pt-8 px-6 pb-4">
              <Stack direction="row">
                <Stack className="flex basis-full" justifyContent="center" alignItems="start">
                  <Skeleton variant="rounded" height={25} width={70} />
                </Stack>
                <Skeleton
                  variant="rectangular"
                  height={44}
                  width={108}
                  sx={{ borderRadius: 320 }}
                />
              </Stack>
              <Stack className="mt-2">
                <Skeleton variant="rounded" width={50} className="ml-auto" />
              </Stack>
            </Box>
            <Box className="relative h-[4px] w-full">
              <Stack
                justifyContent="center"
                alignItems="center"
                className="absolute w-[34px] h-[34px] rounded-full bg-[#4B586A] top-[-17px] left-[50%] ml-[-17px]"
              >
                <ExpandMoreIcon className="flex" />
              </Stack>
            </Box>
            <Box className="w-full bg-[#141A23] rounded-2xl pt-8 px-6 pb-4">
              <Stack direction="row">
                <Stack className="flex basis-full" justifyContent="center" alignItems="start">
                  <Skeleton variant="rounded" height={25} width={50} />
                </Stack>
                <Skeleton
                  variant="rectangular"
                  height={44}
                  width={108}
                  sx={{ borderRadius: 320 }}
                />
              </Stack>
              <Stack className="mt-2">
                <Skeleton variant="rounded" width={40} className="ml-auto" />
              </Stack>
            </Box>
          </Stack>
          <Stack className="w-full py-3" direction="row">
            <Skeleton variant="rounded" height={25} width={50} />
            <Skeleton variant="rounded" height={25} width={80} className="ml-6"/>
          </Stack>
          <Stack className="w-full">
            <Button
              variant="outlined"
              color="secondary"
              size="large"
              fullWidth
              className="bg-gradient-btn border-none relative rounded-full h-[60px] normal-case"
            >
              <Skeleton variant="rounded" width={120} className="mx-auto" />
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}

export default ViewSkeleton
